module.exports = __webpack_public_path__ + "static/media/0323_IMG_TRAD_LES_ENSEIGNES_LE_FROMAGER_LETTRE_A_LETTRE.be5fb687.png";